import { combineReducers, Reducer } from 'redux';
import * as types from './user-settings.types';
import * as constants from './user-settings.constants';
import { isActionOfType } from '../../../../utils/action.utils';

const initialState: types.IUserSettingsPageState = {
  userSettings: {
    userId: null,
    googleCalendarEmbedUrl: null,
    widgets: [],
    createdAt: null,
    updatedAt: null,
  },
};

const userSettingsReducer: Reducer<types.IUserSettingsPageState['userSettings'], types.IUserSettingsPageAction> = (
  state = initialState.userSettings,
  action,
) => {
  if (isActionOfType<types.IStoreUserSettings>(action, constants.STORE_USER_SETTINGS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearUserSettings>(action, constants.CLEAR_USER_SETTINGS)) {
    return initialState.userSettings;
  }
  return state;
};

export const userSettingsPageReducer: Reducer<
  types.IUserSettingsPageState,
  types.IUserSettingsPageAction
> = combineReducers({
  userSettings: userSettingsReducer,
});
